import axios from "axios";
import { checkInEventMangeForSectionV1 } from "./eventLocks";

    const checkCasinoSlug = (slug) => {
        const sectionUrl = store.getters.sectionUrl
        const currentUrl = sectionUrl?.[slug]
        const cached = store.getters.gamesData?.[slug]
        if (cached?.url == currentUrl) {
            return Promise.resolve()
        }
        return casinoApiCall(sectionUrl, slug)
    }


    const casinoApiCall = async (sectionUrl, slug) =>  {
        let url = sectionUrl[slug]
        const { data } = await axios.get(url)
        checkInEventMangeForSectionV1(data)
        store.dispatch('setGamesDatav1', {
            slug,
            data,
            url
        })
    }

export {
    checkCasinoSlug,
};